import { Text, View } from "@react-pdf/renderer";
import { PDFTableColumn } from "components/PDF/Table";
import { ContaRecorrenteItem } from "core/features/conta-recorrente/typings";
import colors from "core/resources/theme/colors";
import { formatMoney } from "infra/helpers/number";
import { useMemo } from "react";
import PDFTag from "ui/components/PDF/components/Tag";

function usePDFContasRecorrentesColumns(): PDFTableColumn<ContaRecorrenteItem>[] {
  return useMemo(() => {
    const columns: PDFTableColumn<ContaRecorrenteItem>[] = [];

    columns.push({
      title: "Descrição",
      flexGrow: 1.35,
      render: (original) => (
        <View>
          <Text>{original?.descricao ?? "--"}</Text>
        </View>
      ),
    });

    columns.push({
      title: "Pessoa",
      flexGrow: 1.35,
      render: (original) => (
        <View>
          <Text>{original?.pessoa?.nome ?? "--"}</Text>
        </View>
      ),
    });

    columns.push({
      title: "Valor",
      flexGrow: 0.8,
      render: (original) => (
        <View>
          <Text>{original?.valor ? formatMoney(original.valor) : "--"}</Text>
        </View>
      ),
    });

    columns.push({
      title: "Intervalo",
      flexGrow: 0.8,
      render: (original) => (
        <View>
          <Text>{original?.tipoIntervaloRepeticao?.nome ?? "--"}</Text>
        </View>
      ),
    });

    columns.push({
      title: "Dia",
      flexGrow: 0.4,
      render: (original) => (
        <View>
          <Text>{original?.diaVencimento ?? "--"}</Text>
        </View>
      ),
    });

    columns.push({
      title: "",
      flexGrow: 0.8,
      render: (original) => (
        <View>
          <PDFTag
            text={`${original.gerada ? "Gerada" : "Não gerada"}`}
            style={{
              variant: "solid",
              color: original.gerada ? colors.green500 : colors.purple,
            }}
          />
        </View>
      ),
    });

    return columns;
  }, []);
}

export default usePDFContasRecorrentesColumns;
